import React, { useEffect, useState } from 'react';
import PlaceholderSlide from './PlaceholderSlide';

import styles from './Slide.module.scss';

type SlideProps = {
  filename: string;
  baseURL: string;
  hyperlink: { url?: string };
  globalState: any;
};

function Slide({ filename, baseURL, hyperlink, globalState }: SlideProps) {
  const { onPageCompleted, getColorScheme } = globalState;
  const { mediaBackground } = getColorScheme();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (loaded) onPageCompleted();
  }, [filename, loaded]); //eslint-disable-line

  function handleOpenHyperlink() {
    hyperlink?.url && window.open(hyperlink?.url);
  }

  const src = `${baseURL}/${filename}`;

  if (!loaded)
    return (
      <PlaceholderSlide>
        {/* eslint-disable-next-line */}
        <img
          src={src}
          style={{ display: 'none' }}
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)} // to not block to next return
        />
      </PlaceholderSlide>
    );

  return (
    <div
      className={styles.Slide}
      style={{
        backgroundImage: `url('${src}')`,
        cursor: hyperlink?.url ? 'pointer' : undefined,
        backgroundColor: mediaBackground,
      }}
      onClick={handleOpenHyperlink}
    ></div>
  );
}

export default Slide;
